import { Component, OnInit, Input } from '@angular/core';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import { curveLinear } from 'd3-shape';
import { PageContainerService } from '../../services';
import {
  ExecutionSummaryDto,
  ExecutionChartDataDto,
  //ExecutionChartDataSeriesDto,
  ExecutionBarChartDto,
  ExecutionChartDataSeriesDto,
  ProjectDto,
  ProjectSetupDto
} from "../../data/CommandServiceDtos.generated";
import { MatDialog } from '@angular/material/dialog';
import { ProjectExecutionScurveComponent } from '../project-execution-scurve/project-execution-scurve.component';
import { SCurveService } from '../../services/scurve.service';
@Component({
  selector: 'project-summary-execution',
  templateUrl: './project-summary-execution.component.html',
  styleUrls: ['./project-summary-execution.component.scss']
})
export class ProjectSummaryExecutionComponent implements OnInit {
  @Input() executionSummary: ExecutionSummaryDto;
  @Input() chartData: ExecutionChartDataDto[];
  @Input() barChartData: ExecutionChartDataSeriesDto[];
  @Input() lineChartData: ExecutionBarChartDto;
  @Input() projectId: number;
  @Input() powerBiReportPath: string;
  @Input() projectDisplayType: string = "";
  @Input() project: ProjectSetupDto = new ProjectSetupDto;


  faSquare = faSquare;
  iconExecutionLink = faClipboardList;
  iconTimeEntryLink = faClock;
  iconStatusReport = faCloudDownloadAlt;
  showStatusReportLink: boolean = false;
  executionOverallComplete: number;
  executionOverallCompleteWidth: number;
  executionProjectedPercentWidth: number;
  executionPlannedComplete: number;
  executionProjectedPercent: number;
  executionPlannedCompleteWidth: number;
  executionLastActivityUpdate: Date;
  curve: any = curveLinear;
  canShowTarReportButton: boolean = false;
  // Chart options
  legend: boolean = false;
  showGridLines: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  legendTitle = '';
  autoScale: boolean = true;
  timeline: boolean = false;
  executionAccessUrl: string;
  timeentryAccessUrl: string;
  projectStatusRptUrl: string;
  baselineTargetFinish: string;
  projectTargetFinish: string;
  projectDataDate: string;

  view = [550, 550]

  colorScheme = {
    domain: ['#E44D25', '#5AA454', '#a08f35']
  };

  openSCurve() {
    const dialogRef = this.dialog.open(ProjectExecutionScurveComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        chartData: this.chartData, projectId: this.projectId, executionSummary: this.executionSummary, project: this.project
      },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  constructor(private pcs: PageContainerService, private dialog: MatDialog, private scurve: SCurveService) {
  }

  ngOnInit() {
    // 788753 - Link added to Dash for report button [Tim Sandberg 10/11/22]
    if (this.projectId === 189) {
      console.log("In projectSummaryExecutionComponent - ngOnInit(), ");

      this.canShowTarReportButton = true;
    } else {
      console.log("In projectSummaryExecutionComponent - ngOnInit(), project Id: " + this.projectId);
    }

    this.setChartData();
  }

  ngOnChanges() {
    this.setChartData();
  }

  setChartData() {
    if (this.lineChartData !== undefined) {
      this.executionOverallComplete = this.lineChartData.ActualPercentComplete;
      this.executionPlannedComplete = this.lineChartData.BaselinePercentComplete;
      this.executionProjectedPercent = this.lineChartData.ProjectedPercentComplete;
      this.executionLastActivityUpdate = this.lineChartData.LastActivityDate;
    } else {
      console.log("In ProjectSummaryExecutionComponent - setChartData(), lineChartData is null.");
    }

    this.executionAccessUrl = this.executionSummary.ExecutionAccessUrl;
    this.timeentryAccessUrl = this.executionSummary.TimeEntryAccessUrl;
    this.projectStatusRptUrl = this.executionSummary.ProjectStatusReportUrl;
    this.baselineTargetFinish = this.executionSummary.BaselineFinishDate;
    this.projectTargetFinish = this.executionSummary.ProjectFinishDate;
    this.projectDataDate = this.executionSummary.ProjectDataDate;

    this.executionOverallCompleteWidth = this.executionOverallComplete;
    this.executionPlannedCompleteWidth = this.executionPlannedComplete;
    this.executionProjectedPercentWidth = this.executionProjectedPercent;
    if (this.executionPlannedComplete > 100) {
      this.executionPlannedCompleteWidth = 100;
      this.executionOverallCompleteWidth = parseInt(((this.executionOverallComplete / this.executionPlannedComplete) * 100).toFixed(0));
    }

  }

  drilldownExecution() {
    if (this.executionAccessUrl === null || this.executionAccessUrl.length === 0) {
      this.pcs.notificationService.warning("Project Schedule not configured for this Project", "", { timeOut: 3000 });
      return;
    }

    window.open(this.executionAccessUrl, "_blank");
  }

  launchTimeEntry() {
    if (this.timeentryAccessUrl === null || this.timeentryAccessUrl.length === 0) {
      this.pcs.notificationService.warning("Project Schedule not configured for this Project", "", { timeOut: 3000 });
      return;
    }

    window.open(this.timeentryAccessUrl, "_blank");
  }

  primaveraStatusReport() {
    if (this.primaveraStatusReport === null || this.projectStatusRptUrl.length === 0) {
      this.pcs.notificationService.warning("Project Status Report Not Available", "Project Status Report not available for this Project", { timeOut: 3000 });
      return;
    }

    window.open(this.projectStatusRptUrl, "_blank");
  }

  chevronBlindFaithTARReport() {
    window.open("https://keystoneengineering.sharepoint.com/teams/solutions/ChevronProjectReadiness/SitePages/Blind_Faith_2022_TAR_Report.aspx", "_blank");
  }
  powerBiReport() {
    window.open(this.powerBiReportPath, "_blank");
  }

  showChart(type) {
    return this.projectDisplayType != undefined ? this.projectDisplayType.includes(type) : false;
  }

  getSecondValueForDate(model: any) {
    return this.scurve.getSecondValueForDate(this.chartData, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/project-summary-execution/project-summary-execution.component.ts